import React, { memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import VerificationCode from 'react-code-input';
import { Formik, Form } from 'formik';
import classNames from 'classnames/bind';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import Back from '../../../shared/components/Back/Back';
import securityCodeSchema from '../../schemas/securityCodeSchema';
import styles from './securityCodeForm.module.scss';

const conditionalStyles = classNames.bind(styles);

export default memo(function SecurityCodeForm(props) {
    const form = useRef(null);
    const { t } = useTranslation('auth');

    const handleSubmit = values => {
        const { securityCode } = values;
        const pathname = props.location.pathname.replace('reset-password-code', '');

        props.storeSecurityCode(securityCode);
        props.history.push(`${pathname}reset-password`);
    };

    return (
        <div className={styles.container}>
            <div className={styles.formContainer}>
                <div className={styles.description}>
                    <span>{t('RECOVER_PASSWORD_SECURITY_CODE')}&nbsp;</span>
                    <span>
                        <strong>{props.email}</strong>.
                </span>
                </div>
                <Formik
                    ref={form}
                    initialValues={{ securityCode: '' }}
                    validationSchema={securityCodeSchema}
                    onSubmit={handleSubmit}
                    render={formProps => (
                        <Form>
                            <div className={styles.fieldsContainer}>
                                <VerificationCode
                                    fields={4}
                                    className={conditionalStyles({
                                        securityCode: true,
                                        securityCodeError: formProps.touched.securityCode && !!formProps.errors.securityCode
                                    })}
                                    inputMode="numeric"
                                    name="securityCode"
                                    onBlur={event => {
                                        form.current.setValues({ securityCode: event });
                                        formProps.handleBlur(event);
                                    }}
                                    onChange={event => {
                                        form.current.setValues({ securityCode: event });
                                        formProps.handleChange(event);
                                    }}
                                    value={formProps.values.securityCode}
                                />
                            </div>
                            <div className={styles.sendButton}>
                                <LoaderButton dictionary="common" text="VERIFY" />
                            </div>
                        </Form>
                    )}
                />
            </div>
            <div className={styles.backContainer}>
                <div className={styles.lineContainer}>
                    <hr />
                </div>
                <Back url={'check-username'} />
            </div>
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.email === nextProps.email &&
        prevProps.storeSecurityCode === nextProps.storeSecurityCode
);
